/*
*@Author: dcl
*@Description: 机构概况
*@Date: 2022-11-15 16:31:59
*/
<template>
<div class="ibo-box">
    <div class="box-right">
        <div class="right-txt">公司名称：东风南方保险代理有限公司河北分公司</div>
        <div class="right-txt">公司住所和营业场所：河北省石家庄市桥西区振岗路156号石家庄市汽车贸易园桥西区销售中心（南区）D5-B号二层</div>
        <div class="right-txt">成立时间：2016年11月1日</div>
        <div class="right-txt">经营范围：代理销售保险产品；代理收取保险费；代理相关保险业务的损失勘察和理赔；保险监督管理机构批准的其他业务</div>
        <div class="right-txt">经营区域：河北省</div>
        <div class="right-txt">主要负责人姓名及职务：沈业巡 河北省分公司负责人</div>
        <div class="right-txt">近两年内撤销分支机构名称、撤销日期：无</div>
        <div class="right-txt">业务合作情况：<a :href="`/static/pdf/hebei_hzxxpl.pdf`" target="_blank" rel="noopener noreferrer">合作保险机构信息披露</a></div>
        <!-- <div class="right-txt">经营互联网保险业务的网站地址：<a href="http://www.elongai.com" target="_blank" rel="noopener noreferrer">www.elongai.com</a>
        </div>
        <div class="right-txt">公司信息披露网站地址：<a href="http://www.elongai.cn" target="_blank" rel="noopener noreferrer">www.dfsi.cn</a></div> -->
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            pot: require('../../assets/board_pot.png'),
            newsList: this.$store.state.newsList,
            timeNewsList: []
        }
    },
    // created() {
    //     this.newsList = this.$store.state.newsList
    //     this.newsList.map((item) => {

    //     })
    // }
}
</script>

<style lang="less" scoped>
.ibo-box {
    display: flex;
    flex-direction: row;
    margin: .73rem 0px;
    padding: .9rem 1.13rem 1.4rem;
    color: #666666;
    background: #FAFAFA;

    .box-right {
        .right-txt {
            // display: flex;
            // flex-direction: row;
            font-size: 0.53rem;
            // margin: .32rem 0;
            line-height: 1.27rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Informationhb/general.vue